import React from 'react';
import Link from 'next/link';
import Image from 'next/image';

export default function HomepageFooter() {
  return (
    <footer className="bg-white border-t border-border py-10">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <Link href="/" className="flex items-center">
            <Image
              src="/assets/images/EFF368A5-5FCF-40DA-8BB5-76EDC09B75CA-1779310043613.png"
              alt="Vaultis logo"
              width={100}
              height={30}
              className="h-7 w-auto object-contain"
            />
          </Link>

          <div className="flex items-center gap-6">
            {['Terms', 'Privacy', 'Compliance', 'Contact']?.map((item) => (
              <Link
                key={item}
                href="#"
                className="text-xs text-muted-foreground hover:text-foreground transition-colors"
              >
                {item}
              </Link>
            ))}
          </div>

          <p className="text-xs text-muted-foreground">
            © 2026 Vaultis. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}